import React from "react";
const extendedReviewData = [{
  id: 0,
  title: "Write a text review",
  description: "Earn $2.00",
  icon: "/uploads/design/2024/9/text-review-icon.svg"
}, {
  id: 1,
  title: "Post a product photo",
  description: "Earn $4.00",
  icon: "/uploads/design/2024/9/photo-review-icon.svg"
}, {
  id: 2,
  title: "Post a product video",
  description: "Earn $10.00",
  icon: "/uploads/design/2024/9/video-review-icon.svg"
}];
const ExtendedReview = () => {
  return <ul className="my-4 ml-0 lg:my-0 lg:flex" data-sentry-component="ExtendedReview" data-sentry-source-file="ExtendedReview.tsx">
      {extendedReviewData.map(item => <li key={item.id} className="
            flex
            lg:flex-col
            justify-start
            items-center
            py-3
            lg:py-0
            border-solid
            border-b
            border-t-0
            border-l-0
            border-r-0
            border-gray-200
            lg:border-none
            last:border-b-0">
          <img src={item.icon} alt="" className="w-12 lg:w-auto mr-4 lg:mr-0" />
          <div className="lg:pt-2 text-sm">
            <span className="font-semibold">{item.title}</span>
            <br />
            <span>{item.description}</span>
          </div>
        </li>)}
    </ul>;
};
export default ExtendedReview;